<template>
  <div class="teaching-catalo-discussion">
    <div class="teaching-catalo-discussion-head">
      <span v-html="title" style="font-weight:bold;"></span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        title:"讨论标题"
    };
  }
};
</script>
<style lang="scss">
.teaching-catalo-discussion {
  width: 100%;
  .teaching-catalo-discussion-head {
    height: 42px;
    padding: 0px 20px;
    line-height: 42px;
    background: #5c9eff;
    .catalo-discussion-head,
    span {
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
